import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useToast } from "../ToastContext/ToastContext";

const BuildingInfoModal = ({ show, handleClose, building }) => {
    const { t } = useTranslation(["usersetting"]);
    const [buildingData, setBuildingData] = useState({});
    const [contactPoints, setContactPoints] = useState([]);

    useEffect(() => {
        if (building) {
            // Mappiamo i campi del building ai nomi corretti
            setBuildingData({
                ...building,
                address: {
                    ...building.address,
                    // Non facciamo il mapping qui perché lo facciamo nel form
                },
                contactPoints: building.contactPoints || [] // map contactPoints -> contactPoints
            });
            setContactPoints(building.contactPoints || []);
        } else {
            // Reset completo per un nuovo building
            setBuildingData({
                description: "",
                address: {
                    country: "",
                    street: "",
                    houseNumber: "",
                    zipCode: "",
                    city: "",
                    region: ""
                },
                contactPoints: []
            });
            setContactPoints([]);
        }
    }, [building, show]); // Aggiungiamo show per resettare quando si riapre il modal

    return (
        <Modal show={show} onHide={() => handleClose(show)} dialogClassName="building-detail-modal" size="xl">
            <Modal.Header closeButton>
                <Modal.Title>
                    {t("usersetting:titles.infobuilding")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>{t("usersetting:caption.description")}</Form.Label>
                        <Form.Control
                            type="text"
                            name="description"
                            value={buildingData?.description || ""}
                            disabled
                        />
                    </Form.Group>

                    {/* Address fields */}
                    <Form.Group className="mb-3">
                        <Form.Label>{t("usersetting:caption.address")}</Form.Label>
                        <Row>
                            <Col sm={6}>
                                <Form.Control
                                    type="text"
                                    name="address.country"
                                    placeholder={t("usersetting:caption.nation")}
                                    value={buildingData.address?.country || ""}
                                    disabled
                                />
                            </Col>
                            <Col sm={6}>
                                <Form.Control
                                    type="text"
                                    name="address.street"
                                    placeholder={t("usersetting:caption.street")}
                                    value={buildingData.address?.street || ""}
                                    disabled
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={6}>
                                <Form.Control
                                    type="text"
                                    name="address.houseNumber"
                                    placeholder={t("usersetting:caption.housenumber")}
                                    value={buildingData.address?.houseNumber || ""}
                                    disabled
                                />
                            </Col>
                            <Col sm={6}>
                                <Form.Control
                                    type="text"
                                    name="address.zipCode"
                                    placeholder={t("usersetting:caption.zipcode")}
                                    value={buildingData.address?.zipCode || ""}
                                    disabled
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={6}>
                                <Form.Control
                                    type="text"
                                    name="address.city"
                                    placeholder={t("usersetting:caption.city")}
                                    value={buildingData.address?.city || ""}
                                    disabled
                                />
                            </Col>
                            <Col sm={6}>
                                <Form.Control
                                    type="text"
                                    name="address.region"
                                    placeholder={t("usersetting:caption.region")}
                                    value={buildingData.address?.region || ""}
                                    disabled
                                />
                            </Col>
                        </Row>
                    </Form.Group>

                    {/* Contact Points Section */}
                    <div className="mt-4">
                        <h5>{t("usersetting:caption.contactpoints")}</h5>
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>{t("usersetting:caption.name")}</th>
                                    <th>{t("usersetting:caption.surname")}</th>
                                    <th>{t("usersetting:caption.email")}</th>
                                    <th>{t("usersetting:caption.phone")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {contactPoints.map((cp, index) => (
                                    <tr key={index}>
                                        <td>
                                            <Form.Control
                                                type="text"
                                                value={cp.name || ""}
                                                disabled
                                            />
                                        </td>
                                        <td>
                                            <Form.Control
                                                type="text"
                                                value={cp.surname || ""}
                                                disabled
                                            />
                                        </td>
                                        <td>
                                            <Form.Control
                                                type="email"
                                                value={cp.email || ""}
                                                disabled
                                            />
                                        </td>
                                        <td>
                                            <Form.Control
                                                type="text"
                                                value={cp.phone || ""}
                                                disabled
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => handleClose(show)}>
                    {t("common:button.close.caption")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default BuildingInfoModal;